import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { RootService } from 'src/app/services/root/root.service';
import { Client } from '../activity/models/Client';
import { DatePipe } from '@angular/common';
import { Activity } from './models/Activity/activity.model';
import * as _ from 'lodash';
import * as moment from 'moment';

@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss']
})

export class ActivityComponent implements OnInit {
  show: boolean = false;
  clients: any;
  options: Client[];
  filteredClients: any;
  activityForm: FormGroup;
  dataSource = new MatTableDataSource<Activity[]>();
  displayedColumns: string[] = ['empresa', 'comprobante', 'fecha', 'debe', 'haber', 'pdf'];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private _rootService: RootService,
    private datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder
  ) { }


  ngOnInit() {

    const now = moment().format('YYYY-MM-DD');

    this.clients = JSON.parse(sessionStorage.getItem("session"));
    this.options = this.clients["dsSesion"]["ttcliente"];

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    console.log(this.dataSource);

    /** Form initiated */
    this.activityForm = this.formBuilder.group({
      code: [this.clients.dsSesion.ttcliente[0].codigo, Validators.required],
      since: [moment().subtract(3, 'months').format('YYYY-MM-DD'), Validators.required],
      from: [now, Validators.required]
    });

    if (this.clients.dsSesion.ttsesion[0].tipo == 'cliente') {
      const now = moment().format('YYYY-MM-DD');
      this.activityForm = this.formBuilder.group({
        code: [this.clients.dsSesion.ttcliente[0].codigo, Validators.required],
        since: [moment().subtract(3, 'months').format('YYYY-MM-DD'), Validators.required],
        from: [now, Validators.required]
      });

      this.onSubmit(this.activityForm);
    }
  }

  filterClients(value: any) {
    let filterValue = value.toString().toUpperCase();
    this.filteredClients = this.options.filter(client => client.nombre.toUpperCase().indexOf(filterValue) === 0 || client.codigo.toString().includes(filterValue));
  }

  onSubmit(obj: FormGroup) {

    this.spinner.show();
    this.show = true;

    /** Form validation */
    if (obj.status === "INVALID") {
      this.spinner.hide();
      return this.showAlert("Campos Requeridos*", "Cerrar");
    }

    /** Headache: tranform date form date picker to format legible by the api */
    let s = this.datepipe.transform(obj.value.since, 'dd/MM/yyyy');
    let f = this.datepipe.transform(obj.value.from, 'dd/MM/yyyy');

    /** Callback to the api*/
    return this._rootService.activities(obj.value.code["codigo"], s, f).subscribe((response) => {

      if (!_.get(response, 'movi')) {
        this.showAlert("No se encontraron datos", "Cerrar");
        this.show = false;
        this.spinner.hide();
      }

      this.dataSource.data = response["movi"];
      this.show = true;
      this.spinner.hide();

    }, (error) => {

      this.showAlert("Error, vuelva a intentar", "Cerrar");
      this.show = false;
      this.spinner.hide();

    });
  }

  displayNm(client: any) {
    return client ? client["nombre"] : undefined;
  }

  /** Alert method */
  showAlert(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }

  /** Filter */
  applyFilter(filterValue: string): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
